"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MHPGrantType = exports.MHPTokenType = void 0;
var MHPTokenType;
(function (MHPTokenType) {
    MHPTokenType["FHIR"] = "fhir";
    MHPTokenType["USER_VISITPAY_PING"] = "user/visitPay/ping";
    MHPTokenType["VISITPAY"] = "visitpay";
    MHPTokenType["SYSTEM_CERNER_FHIR_DSTU2"] = "system/cerner/fhir/dstu2";
    MHPTokenType["SYSTEM_CERNER_FHIR_R4"] = "system/cerner/fhir/r4";
    MHPTokenType["USER_CERNER_FHIR_DSTU2"] = "user/cerner/fhir/dstu2";
    MHPTokenType["USER_CERNER_FHIR_R4"] = "user/cerner/fhir/r4";
    MHPTokenType["SYSTEM_CONSUMER_PING"] = "system/consumer/ping";
    MHPTokenType["SYSTEM_CAREGIVER_PING"] = "system/caregiver/ping";
    MHPTokenType["USER_AMWELL_PING"] = "user/amwell/ping";
    MHPTokenType["AMWELL"] = "amwell";
    MHPTokenType["SYSTEM_GYANT"] = "system/gyant";
    MHPTokenType["SYSTEM_JWT"] = "system/jwt";
})(MHPTokenType || (exports.MHPTokenType = MHPTokenType = {}));
var MHPGrantType;
(function (MHPGrantType) {
    MHPGrantType["CLIENT"] = "client_credentials";
    MHPGrantType["PASSWORD"] = "password";
    MHPGrantType["REFRESH"] = "refresh_token";
})(MHPGrantType || (exports.MHPGrantType = MHPGrantType = {}));
//# sourceMappingURL=mhp-token-type.enum.js.map